import Tooltip from "components/design-system/tooltip";
import Price from "components/source/grid/price";
import { showDecimal } from "helpers/price-helper";
import { useSelector } from "react-redux";
import { Faq } from "routes";

export default function Header() {
  const staticProduct = useSelector(state => state.staticProduct);
  const { designerId, designerDisplayName: designerName, displayName: styleName, msrp } = staticProduct;

  const originalPrice = (
    <div className="w-64 p-2">
      This number represents the “Original Retail” or “Comparable Value” price. Items may be in the rental rotation for
      multiple seasons after these prices are set. For more info on these prices, see our{" "}
      <a href={Faq.purchasePricing} rel="noopener noreferrer" target="_blank">
        FAQs
      </a>
    </div>
  );

  return (
    <div data-test-id="pdp-header" className="pdp-header">
      <div className="flex justify-between items-center">
        <h1 className="font-sans text-md text-darkerGray pb-2" itemProp="name" aria-label="Product Name">
          {styleName}
        </h1>
      </div>
      <h2 className="font-sans text-h4 underline pb-2">
        <a href={"/designers/" + designerId + "?source=pdp"}>{designerName}</a>
      </h2>

      <div className="flex items-center gap-1 text-darkGray">
        <Price
          amount={msrp}
          currencyCode={"USD"}
          currencyCodeClassName="hidden @[275px]/label:inline"
          showDecimal={showDecimal(msrp)}
        />
        <span>original retail</span>
        <Tooltip tooltipContent={originalPrice} />
      </div>
    </div>
  );
}
